import React from "react";
import { useNavigate } from "react-router-dom";
import { Stack, Text, Title } from "@mantine/core";
import { Button, spacePx } from "@xplatform/design-system";
import { IconLock } from "@tabler/icons-react";

const PermissionErrorPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Stack align="center" justify="center" h="100%" gap="md" pt={spacePx[20]}>
            <IconLock size={64} stroke={1.2} color="var(--mantine-color-red-6)" />
            <Title order={2}>Access Denied</Title>
            <Text c="dimmed" ta="center" maw={420}>
                You don't have permission to view this page. Contact your administrator
                if you believe this is a mistake.
            </Text>
            <Button variant="light" onClick={() => navigate(-1)}>
                Go back
            </Button>
        </Stack>
    );
};

export default PermissionErrorPage;
